import { render, staticRenderFns } from "./CustomerMembershipLogDetail.vue?vue&type=template&id=515ab0ed"
import script from "./CustomerMembershipLogDetail.vue?vue&type=script&lang=js"
export * from "./CustomerMembershipLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports